export enum SEND_CONTRACT_FIELDS {
	BENEFICIARY = 'beneficiaire',
	DEMANDE = 'demande',
	MUTUELLE = 'mutuelle',
	MUTUELLE_FILE = 'mutuelleFile',
	FILES = 'files',
	COMMENTAIRE = 'commentaire'
}
